import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const points = ['Te levantás con la panza plana y a las 2 horas parece que estás de 5 meses.', 'Los gases te generan vergüenza y miedo a comer afuera.', 'Tomás probióticos del súper sin ver resultados reales.', 'El médico te dijo “es estrés” y te mandó a casa sin un plan.', 'Gastaste en consultas y suplementos que solo te dieron respuestas parciales.'];
export function PainPoints() {
  return <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-86" data-mp="21zuphd9wghvk">
      <div className="mx-auto max-w-4xl" data-id="element-87" data-mp="21x8ibeqx84dv">
        <header className="text-center" data-id="element-88" data-mp="1o03elleojhls">
          <h2 className="font-display sm:text-5xl text-[24px] font-[700]" data-id="element-89" data-mp="1o14wa8q7b2ch">¿Cuánto tiempo más vas a seguir con la panza inflada como un globo?</h2>
          <p className="mx-auto mt-6 max-w-3xl text-slate-300 font-[600]" data-id="element-90" data-mp="3idupeo8qw7it">Comés bien, probaste de todo y la hinchazón sigue. No es falta de voluntad. Solo necesitabas el mapa correcto para entender tu intestino.</p>
          <p className="mt-4 font-semibold text-brand-light" data-id="element-91" data-mp="1yzvidgbxglte">No es tu culpa. Te faltaba un sistema claro.</p>
        </header>
        <div className="mt-10 space-y-3" data-id="element-92" data-mp="1u0skcfud7fux">
          {points.map((point, index) => <motion.div key={point} initial={{
          opacity: 0,
          x: -14
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex gap-3 rounded-xl border border-red-900/70 bg-[#250c0c] p-4 sm:p-5" data-id="element-93" data-mp="27t8hx14hylog" data-mpi={index}>
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-94" data-mp="1g3x1jvobaa1o" />
              <p className="text-sm leading-relaxed text-slate-200 sm:text-base" data-id="element-95" data-mp="1b4stj8d4iicx">{point}</p>
            </motion.div>)}
        </div>
        <p className="mt-12 text-center font-display font-bold italic text-brand-gold sm:text-3xl text-[20px]" data-id="element-96" data-mp="1k3nyyi8cfof6">¿Y si pudieras tener un mapa claro para identificar qué está inflamando tu intestino y corregirlo desde hoy?</p>
      </div>
    </section>;
}